// pages/index/components/DigiFreeBadge.tsx
import { Box } from "@mui/material";
import digifreeBannerUrl from "@images/digifree_banner.png";

/**
 * DigiFreeBadge - Displays the "Discounts with DigiFree" badge
 * Only shown when organization has isDigifreeSubscribed = true
 */

interface DigiFreeBadgeProps {
    onClick?: () => void;
}

export const DigiFreeBadge = ({ onClick }: DigiFreeBadgeProps) => {
    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: onClick ? "pointer" : "default",
                mb: 3,
                px: { xs: 2, sm: 0 }, // Add horizontal padding on mobile
                transition: "opacity 0.2s ease",
                "&:hover": onClick
                    ? {
                        opacity: 0.8,
                    }
                    : undefined,
            }}
        >
            <Box
                component="img"
                src={digifreeBannerUrl}
                alt="Discounts with digiFREE - Search Event Discounts"
                sx={{
                    display: "block",
                    width: "100%",
                    maxWidth: {
                        xs: "100%", // Mobile: full width (with padding from parent)
                        sm: "400px", // Tablet: 400px max
                        md: "525px", // Desktop: 525px max
                    },
                    height: "auto",
                }}
            />
        </Box>
    );
};
